/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Single sector experience dropdown for the certifications section.
 * @module components/AppointmentRegistrationSections/Certifications/SectorExperienceSelect
 */

import { useCallback } from "react";
import Select from "react-select";
import { getSelectedOption } from "../../../utils/common";

/**
 * Renders one years-of-experience picker bound to a sector value.
 * @param {Object} props
 * @param {Object} props.sector - Sector entry with `value` and `experience`
 * @param {Array} props.yearsOptions - react-select options for years of experience
 * @param {string} props.placeholder - Localized placeholder text
 * @param {Object} props.selectStyles - react-select style overrides
 * @param {Function} props.onExperienceChange - `(sectorValue, selectedOption) => void`
 */
const SectorExperienceSelect = ({
  sector,
  yearsOptions,
  placeholder,
  selectStyles,
  onExperienceChange,
}) => {
  const handleChange = useCallback(
    (selectedOption) => onExperienceChange(sector.value, selectedOption),
    [onExperienceChange, sector.value],
  );

  return (
    <Select
      value={getSelectedOption(yearsOptions, sector.experience)}
      onChange={handleChange}
      options={yearsOptions}
      placeholder={placeholder}
      styles={selectStyles}
      className="select__control"
    />
  );
};

export default SectorExperienceSelect;
